import { ISelectOptions } from '../../components/Inputs/Select';
import { SELECT_NONE_OPTION } from '../../utils/noneOptionUtil';

const NONE_THERAPY_TYPE = 0;

export interface ITypeOfCarOption extends ISelectOptions {
  therapyType?: number;
  displayName?: string;
}

export enum therapyTypeEnum {
  'no type of care' = NONE_THERAPY_TYPE,
  'Skilled Therapy' = 1,
  'Not in Skilled Therapy' = 2,
  'Other' = 3,
}

export const SELECT_NONE_THERAPY_TYPE_OPTION = {
  ...SELECT_NONE_OPTION,
  label: `${SELECT_NONE_OPTION.label} [${therapyTypeEnum[NONE_THERAPY_TYPE]}]`,
  therapyType: NONE_THERAPY_TYPE,
};
